import type { BackofficeAuthUser } from '@/features/backoffice2020/types/backoffice-auth.types';

function asString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function asNullableString(value: unknown): string | null {
  const normalized = asString(value);
  return normalized || null;
}

function asNumber(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function asBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 1 || value === '1' || value === 'true') {
    return true;
  }
  return false;
}

export function normalizeBackofficeAuthUser(
  value: unknown,
): BackofficeAuthUser | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const record = value as Record<string, unknown>;
  const id = asNumber(record.id);
  const email = asString(record.email);
  const name = asString(record.name);

  if (id == null || (!email && !name)) {
    return null;
  }

  return {
    id,
    email,
    name,
    role: asString(record.role),
    isActive: asBoolean(record.is_active ?? record.isActive),
    lastLoginAt: asNullableString(record.last_login_at ?? record.lastLoginAt),
  };
}

export function getBackofficeDisplayName(
  user: BackofficeAuthUser | null | undefined,
): string | null {
  if (!user) {
    return null;
  }
  if (user.name.trim()) {
    return user.name.trim();
  }
  if (user.email.trim()) {
    return user.email.trim();
  }
  return null;
}
